import { useBreakpointValue } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useState } from "react";
import { Button } from "../../forms/button/Button";
import { Box } from "../../layout/box/Box";
import { H } from "../heading/A11yHeading";
import { styles } from "./PageHeading.styles";
import { mapSizesDescription, mapSizesTitle } from "./mapSizes";

export interface PageHeadingProps {
    title: string;
    description: string | ReactNode;
    showMoreLabel?: string;
    showLessLabel?: string;
    id?: string;
    titleSize?: string;
    descriptionSize?: string;
    resultsCount?: number;
}

export const PageHeading = ({
    title,
    description,
    showMoreLabel,
    showLessLabel,
    id,
    titleSize = "Extra Large",
    descriptionSize = "Normal",
    resultsCount,
}: PageHeadingProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const handleToggle = () => setIsExpanded((prevState) => !prevState);
    const maxLines = useBreakpointValue({ base: 2, lg: 3 });

    return (
        <Box sx={styles.container}>
            {title && (
                <H
                    as="h1"
                    size="h1"
                    fontWeight="bold"
                    data-contentful-entry-id={id}
                    data-contentful-field-id="title"
                    fontSize={mapSizesTitle[titleSize]}
                    resultsCount={resultsCount}
                >
                    {title}
                </H>
            )}
            {description && (
                <Box sx={styles.descriptionContainer}>
                    <Box
                        data-contentful-entry-id={id}
                        data-contentful-field-id="desc"
                        sx={{
                            ...styles.description,

                            WebkitLineClamp: isExpanded ? "none" : maxLines,
                            "& p": {
                                mb: isExpanded && 0,
                                fontWeight: "bold",
                                fontSize: mapSizesDescription[descriptionSize],
                            },
                        }}
                    >
                        {description}
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Button onClick={handleToggle} variant="link">
                            {isExpanded ? showLessLabel : showMoreLabel}
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
};
